(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auction-listing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-auction-listing]');
    if (!root) return;
    var lotList = root.querySelector('.lot-list');
    var emptyState = root.querySelector('.empty-state');
    var countEl = root.querySelector('.auc-toolbar .count');
    var activeFilter = 'all';
    var saleDescription = root.dataset.saleDescription || '';
    var loginUrl = root.dataset.loginUrl || '/pages/login';
    var currentAuction = null;

    function rows() {
      return Array.prototype.slice.call(lotList.querySelectorAll('.lot-row'));
    }
    function saleTitle() {
      return root.dataset.saleTitle || 'Auction';
    }

    function matches(row, f) {
      if (f === 'all') return true;
      var status = row.dataset.status;
      var cat = row.dataset.cat;
      var low = parseInt(row.dataset.low, 10) || 0;
      var high = parseInt(row.dataset.high, 10) || low;
      if (f === 'live') return status === 'live';
      if (f === 'upcoming') return status === 'upcoming';
      if (f === 'price-lt-2000') return high > 0 && high < 2000;
      if (f === 'price-2000-10000') return high >= 2000 && low <= 10000;
      if (f === 'price-10000-50000') return high >= 10000 && low <= 50000;
      if (f === 'price-gt-50000') return high >= 50000 || low >= 50000;
      if (f.indexOf('cat-') === 0) return cat === f.slice(4);
      return true;
    }
    function applyFilter() {
      var visible = 0;
      rows().forEach(function (r) {
        var ok = matches(r, activeFilter);
        r.style.display = ok ? '' : 'none';
        if (ok) visible++;
      });
      if (countEl) {
        countEl.innerHTML = (activeFilter === 'all' ? 'All lots' : 'Filtered') + ' <span>· ' + visible + '</span>';
      }
      if (emptyState) emptyState.hidden = visible !== 0;
    }
    root.addEventListener('click', function (event) {
      var b = event.target.closest('[data-filter-chips] button');
      if (!b || !root.contains(b)) return;
      // Server category chips are handled by auctions-bridge.js
      if (b.hasAttribute('data-server-cat')) return;
      root.querySelectorAll('[data-filter-chips] button').forEach(function (x) {
        x.classList.remove('on');
      });
      b.classList.add('on');
      activeFilter = b.dataset.filter || 'all';
      if (activeFilter === 'all') {
        root.dispatchEvent(new CustomEvent('selloff:clear-server-filters'));
      }
      applyFilter();
    });

    var sortSelect = root.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function (e) {
        var v = e.target.value;
        var sorted = rows().slice().sort(function (a, b) {
          if (v === 'num') return parseInt(a.dataset.num, 10) - parseInt(b.dataset.num, 10);
          if (v === 'low') return parseInt(a.dataset.low, 10) - parseInt(b.dataset.low, 10);
          if (v === 'high') return parseInt(b.dataset.high, 10) - parseInt(a.dataset.high, 10);
          if (v === 'closing') return (a.dataset.status === 'live' ? 0 : 1) - (b.dataset.status === 'live' ? 0 : 1);
          return 0;
        });
        sorted.forEach(function (r) {
          lotList.appendChild(r);
        });
      });
    }

    root.querySelectorAll('.view-toggle button').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.view-toggle button').forEach(function (x) {
          x.classList.remove('on');
        });
        b.classList.add('on');
        if (b.dataset.view === 'grid') lotList.classList.add('as-grid');
        else lotList.classList.remove('as-grid');
      });
    });

    var calBtn = root.querySelector('[data-act-calendar]');
    if (calBtn) {
      calBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var title = saleTitle();
        var ics = [
          'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Winwin Geneve//EN',
          'BEGIN:VEVENT', 'UID:' + title.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '@winwin-geneve',
          'DTSTAMP:20260901T000000Z',
          'DTSTART:' + (root.dataset.icsStart || '20260912T100000Z'),
          'DTEND:' + (root.dataset.icsEnd || '20261003T180000Z'),
          'SUMMARY:Winwin Genève — ' + title,
          'DESCRIPTION:' + saleDescription,
          'LOCATION:Online',
          'END:VEVENT', 'END:VCALENDAR'
        ].join('\r\n');
        var blob = new Blob([ics], { type: 'text/calendar' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = title.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.ics';
        a.click();
      });
    }

    var shareBtn = root.querySelector('[data-act-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var title = saleTitle();
        var data = { title: 'Winwin Genève — ' + title, text: saleDescription, url: location.href };
        if (navigator.share) navigator.share(data).catch(function () {});
        else if (navigator.clipboard)
          navigator.clipboard.writeText(location.href).then(function () {
            shareBtn.textContent = 'Link copied';
          });
      });
    }

    var printBtn = root.querySelector('[data-act-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function (e) {
        if (printBtn.dataset.pdfHref) {
          // Open Selloff catalogue PDF (user can print from the PDF viewer).
          return;
        }
        e.preventDefault();
        var prev = printBtn.textContent;
        printBtn.textContent = 'PDF not available yet';
        setTimeout(function () {
          printBtn.textContent = prev;
        }, 1800);
      });
    }

    var dlBtn = root.querySelector('[data-act-download]');
    if (dlBtn) {
      dlBtn.addEventListener('click', function (e) {
        if (dlBtn.dataset.pdfHref) {
          // Real catalogue PDF from Selloff — open in a new tab.
          return;
        }
        e.preventDefault();
        // No generated .txt fallback — wait for pdf_catalogue in Selloff.
        var prev = dlBtn.textContent;
        dlBtn.textContent = 'PDF not available yet';
        setTimeout(function () {
          dlBtn.textContent = prev;
        }, 1800);
      });
    }

    var followBtn = root.querySelector('[data-act-follow]');

    function paintFollow() {
      if (!followBtn || !window.WinwinFollows || !currentAuction) return;
      var on = window.WinwinFollows.isFollowing(currentAuction.idauction);
      followBtn.textContent = on ? 'Following ✓' : 'Follow';
      followBtn.classList.toggle('following', on);
      followBtn.title = on
        ? 'Saved in your account watchlist. Click to unfollow.'
        : 'Follow this auction to track it in your account';
    }

    if (followBtn) {
      followBtn.addEventListener('click', async function () {
        if (!window.WinwinFollows) return;
        if (!currentAuction || currentAuction.idauction == null) {
          followBtn.textContent = 'Unavailable';
          return;
        }

        var apiBase = (root.dataset.apiDirect || 'https://api.winwingeneve.ch').replace(/\/$/, '');
        var authed = false;
        if (window.WinwinApi) {
          try {
            var session = await window.WinwinApi.request(apiBase, '/session');
            authed = !!(session.ok && session.data && session.data.authenticated);
          } catch (e) {
            authed = false;
          }
        }
        if (!authed) {
          window.location.href = loginUrl + '?next=' + encodeURIComponent(window.location.pathname + window.location.search);
          return;
        }

        if (window.WinwinFollows.isFollowing(currentAuction.idauction)) {
          window.WinwinFollows.unfollow(currentAuction.idauction);
          paintFollow();
          return;
        }

        var permission = 'default';
        try {
          permission = await window.WinwinFollows.requestNotifyPermission();
        } catch (e) {
          permission = 'denied';
        }
        window.WinwinFollows.follow(currentAuction, { notify: permission === 'granted' });
        paintFollow();

        var prev = followBtn.textContent;
        if (permission === 'granted') {
          followBtn.textContent = 'Following · alerts on';
        } else if (permission === 'denied' || permission === 'unsupported') {
          followBtn.textContent = 'Following · see account';
        } else {
          followBtn.textContent = 'Following ✓';
        }
        setTimeout(paintFollow, 1600);
      });
    }

    root.addEventListener('selloff:loaded', function (event) {
      currentAuction = (event.detail && event.detail.auction) || null;
      if (currentAuction && window.WinwinFollows) {
        paintFollow();
        window.WinwinFollows.checkOpenAlerts(currentAuction);
      }
      activeFilter = 'all';
      root.querySelectorAll('.filter-chips button').forEach(function (x, i) {
        x.classList.toggle('on', i === 0);
      });
      applyFilter();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalogue-flipbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-catalogue]');
    if (!root) return;
    var spreads = root.querySelectorAll('.cat-spread');
    var curEl = root.querySelector('[data-cat-cur]');
    var totalEl = root.querySelector('[data-cat-total]');
    var prevBtn = root.querySelector('[data-cat-prev]');
    var nextBtn = root.querySelector('[data-cat-next]');
    var i = 0;
    if (totalEl) totalEl.textContent = spreads.length;

    function go(n) {
      i = Math.max(0, Math.min(spreads.length - 1, n));
      spreads.forEach(function (s, k) {
        s.classList.toggle('on', k === i);
      });
      if (curEl) curEl.textContent = i + 1;
      prevBtn.disabled = i === 0;
      nextBtn.disabled = false;
      nextBtn.textContent = i === spreads.length - 1 ? 'Get the full catalogue →' : 'Next →';
    }
    prevBtn.addEventListener('click', function () {
      go(i - 1);
    });
    nextBtn.addEventListener('click', function () {
      if (i === spreads.length - 1) {
        openCatalogueModal();
        return;
      }
      go(i + 1);
    });
    document.addEventListener('keydown', function (e) {
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;
      if (e.key === 'ArrowLeft') go(i - 1);
      if (e.key === 'ArrowRight') {
        if (i === spreads.length - 1) {
          openCatalogueModal();
          return;
        }
        go(i + 1);
      }
    });
    go(0);

    var modal = document.getElementById('catalogue-modal');
    if (!modal) return;
    var emailInput = document.getElementById('cat-email');
    var formWrap = document.getElementById('catalogue-modal-form');
    var successWrap = document.getElementById('catalogue-modal-success');
    var lastFocus = null;

    function openCatalogueModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.body.classList.add('modal-open');
      setTimeout(function () {
        if (emailInput) emailInput.focus();
      }, 80);
    }

    // Shopify's customer form redirects back with ?customer_posted=true —
    // reopen the modal in its success state so the visitor sees confirmation.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      if (formWrap) formWrap.style.display = 'none';
      if (successWrap) successWrap.classList.add('on');
      openCatalogueModal();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('modal-open');
      setTimeout(function () {
        modal.hidden = true;
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }, 250);
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modal.querySelectorAll('[data-close-catalogue]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    try {
      var root = document.querySelector('[data-coming-soon]');
      if (!root) return;
      var zfFrame = root.querySelector('[data-coming-soon-zoho-iframe]');
      if (!zfFrame || !zfFrame.src) return;
      var ifrmSrc = zfFrame.src;
      if (/[?&]referrername=/.test(ifrmSrc)) return;
      var rfr = window.location.href;
      try {
        rfr =
          window.self !== window.top
            ? window.top.location.href
            : /^https?:\/\/[\w.-]+\.[a-zA-Z]{2,}/i.test(rfr)
              ? rfr
              : '';
      } catch (err) {}
      if (!rfr) return;
      if (rfr.length > 1800) {
        var q = rfr.indexOf('?');
        if (q > -1) rfr = rfr.substring(0, q);
        if (rfr.length > 1800) rfr = rfr.substring(0, 1800);
      }
      ifrmSrc += (ifrmSrc.indexOf('?') > 0 ? '&' : '?') + 'referrername=' + encodeURIComponent(rfr);
      zfFrame.src = ifrmSrc;
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["consign-form"] && !Shopify.designMode) return;
  try {
    
  function initConsignZohoResize() {
    var embed = document.querySelector('[data-consign-zoho-embed]');
    if (!embed) return;

    function getIframe() {
      return embed.querySelector('[data-consign-zoho-iframe]') || embed.querySelector('iframe');
    }

    window.addEventListener('message', function (event) {
      if (typeof event.data !== 'string' || event.data.indexOf('|') === -1) return;

      var parts = event.data.split('|');
      var zfPerma = parts[0];
      var nextHeight = parseInt(parts[1], 10);
      if (!zfPerma || isNaN(nextHeight)) return;

      var iframe = getIframe();
      if (!iframe || iframe.src.indexOf('formperma') === -1 || iframe.src.indexOf(zfPerma) === -1) return;

      var heightValue = (nextHeight + 15) + 'px';
      if (iframe.style.height !== heightValue) {
        iframe.style.height = heightValue;
        embed.style.height = heightValue;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConsignZohoResize);
  } else {
    initConsignZohoResize();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function initContactZohoResize() {
    var embed = document.querySelector('[data-contact-zoho-embed]');
    if (!embed) return;

    function getIframe() {
      return embed.querySelector('[data-contact-zoho-iframe]') || embed.querySelector('iframe');
    }

    function applyHeight(nextHeight) {
      var iframe = getIframe();
      if (!iframe || isNaN(nextHeight) || nextHeight < 200) return;

      var heightValue = Math.ceil(nextHeight + 8) + 'px';
      iframe.style.height = heightValue;
      embed.style.height = heightValue;
    }

    window.addEventListener('message', function (event) {
      if (!event.origin || event.origin.indexOf('zohopublic') === -1) return;

      var iframe = getIframe();
      if (!iframe) return;

      if (typeof event.data === 'string' && event.data.indexOf('|') !== -1) {
        var parts = event.data.split('|');
        var zfPerma = parts[0];
        var nextHeight = parseInt(parts[1], 10);
        if (!zfPerma || isNaN(nextHeight)) return;
        if (iframe.src.indexOf(zfPerma) === -1) return;
        applyHeight(nextHeight);
      }
    });
  }

  function loadBookingsEmbed(callback) {
    if (window.Bookings) {
      callback();
      return;
    }
    var existing = document.querySelector('script[data-bookings-embed]');
    if (existing) {
      existing.addEventListener('load', callback);
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://bookings.nimbuspop.com/assets/embed.js';
    script.async = true;
    script.setAttribute('data-bookings-embed', '');
    script.onload = callback;
    document.head.appendChild(script);
  }

  function initAppointmentModal() {
    var modal = document.getElementById('appointment-modal');
    if (!modal) return;

    var openers = document.querySelectorAll('[data-open-appointment]');
    var closers = modal.querySelectorAll('[data-close-appointment]');
    var bookingButtons = modal.querySelectorAll('[data-zoho-booking-url]');
    var lastFocus = null;

    function openModal(event) {
      if (event) event.preventDefault();
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.body.classList.add('modal-open');
      var firstButton = modal.querySelector('[data-zoho-booking-url]');
      if (firstButton) firstButton.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('modal-open');
      setTimeout(function () {
        modal.hidden = true;
      }, 250);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    loadBookingsEmbed(function () {
      if (!window.Bookings) return;
      bookingButtons.forEach(function (btn) {
        var url = btn.getAttribute('data-zoho-booking-url');
        if (!url) return;
        var openBooking = Bookings.linkModal({ url: url });
        btn.addEventListener('click', function (event) {
          closeModal();
          setTimeout(function () {
            openBooking(event);
          }, 280);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initContactZohoResize();
      initAppointmentModal();
    });
  } else {
    initContactZohoResize();
    initAppointmentModal();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var toggle = nav.querySelector('[data-nav-drawer-toggle]');
    var drawer = nav.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      nav.classList.add('is-drawer-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        nav.classList.add('is-drawer-open');
      });
    }

    function closeDrawer() {
      nav.classList.remove('is-drawer-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        if (!nav.classList.contains('is-drawer-open')) drawer.hidden = true;
      }, 280);
    }

    function toggleDrawer() {
      if (nav.classList.contains('is-drawer-open')) closeDrawer();
      else openDrawer();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleDrawer();
    });

    drawer.querySelectorAll('[data-nav-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Search (unchanged) */
    var root = document.querySelector('[data-nav-search]');
    if (!root) return;

    var searchToggle = root.querySelector('[data-nav-search-toggle]');
    var form = root.querySelector('[data-nav-search-form]');
    var input = root.querySelector('[data-nav-search-input]');
    var results = root.querySelector('[data-nav-search-results]');
    var debounceTimer;

    function openSearch() {
      root.classList.add('is-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      input.focus();
    }

    function closeSearch() {
      root.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      if (results) {
        results.hidden = true;
        results.innerHTML = '';
      }
    }

    searchToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (root.classList.contains('is-open')) closeSearch();
      else openSearch();
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeSearch();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (!results) return;
      if (q.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=page,product,article&resources[limit]=5';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = [];
            var resources = data.resources && data.resources.results;
            if (resources) {
              ['pages', 'products', 'articles'].forEach(function (type) {
                if (resources[type]) items = items.concat(resources[type]);
              });
            }
            if (!items.length) {
              results.innerHTML = '<p>No quick results. Press Enter to search the site.</p>';
            } else {
              results.innerHTML = items.map(function (item) {
                return '<a href="' + item.url + '">' + item.title + '</a>';
              }).join('');
            }
            results.hidden = false;
          })
          .catch(function () {
            results.hidden = true;
          });
      }, 220);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lot-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var galleryMain = document.querySelector('.lot-gallery .gallery-main');
    var thumbs = document.querySelectorAll('.lot-gallery .thumb');
    if (!galleryMain || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbImg = thumb.querySelector('img');
        if (thumbImg) {
          var mainImg = galleryMain.querySelector('img');
          if (mainImg) {
            mainImg.src = thumbImg.src;
            if (thumbImg.srcset) mainImg.srcset = thumbImg.srcset;
            mainImg.alt = thumbImg.alt;
          }
        }
        thumbs.forEach(function (t) {
          t.classList.remove('active');
        });
        thumb.classList.add('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-nl-popup]');
    if (!root) return;

    var key = root.getAttribute('data-storage-key') || 'ww_newsletter_popup_v1';
    var delay = parseInt(root.getAttribute('data-delay') || '10', 10);
    if (isNaN(delay) || delay < 0) delay = 10;

    var timer;
    var designMode = !!(window.Shopify && Shopify.designMode);

    function seen() {
      try {
        return localStorage.getItem(key) === '1';
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      try {
        localStorage.setItem(key, '1');
      } catch (e) {}
    }

    function openPopup() {
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closePopup() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      markSeen();
    }

    root.querySelectorAll('[data-nl-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closePopup();
    });

    // Zoho referrer tracking (from Zoho iframe embed snippet)
    try {
      var zfFrame = root.querySelector('[data-nl-zoho-iframe]');
      if (zfFrame && zfFrame.src) {
        var ifrmSrc = zfFrame.src;
        if (!(/[?&]referrername=/.test(ifrmSrc))) {
          var rfr = window.location.href;
          try {
            rfr = window.self !== window.top ? window.top.location.href : rfr;
          } catch (err) {}
          if (rfr && rfr !== '') {
            if (rfr.length > 1800) {
              var q = rfr.indexOf('?');
              if (q > -1) rfr = rfr.substring(0, q);
              if (rfr.length > 1800) rfr = rfr.substring(0, 1800);
            }
            ifrmSrc += (ifrmSrc.indexOf('?') > 0 ? '&' : '?') + 'referrername=' + encodeURIComponent(rfr);
            zfFrame.src = ifrmSrc;
          }
        }
      }
    } catch (e) {}

    if (seen() && !designMode) return;

    timer = window.setTimeout(function () {
      if (!designMode && seen()) return;
      openPopup();
    }, delay * 1000);

    document.addEventListener('shopify:section:unload', function () {
      clearTimeout(timer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-team-section]');
    if (!section) return;

    var modal = section.querySelector('[data-team-modal]');
    if (!modal) return;

    var dialog = modal.querySelector('[data-team-dialog]');
    var profilePanel = modal.querySelector('[data-team-modal-profile]');
    var media = modal.querySelector('[data-team-modal-media]');
    var img = modal.querySelector('[data-team-modal-img]');
    var roleEl = modal.querySelector('[data-team-modal-role]');
    var nameEl = modal.querySelector('[data-team-modal-name]');
    var bioEl = modal.querySelector('[data-team-modal-bio]');
    var actionsEl = modal.querySelector('[data-team-modal-actions]');
    var lastFocus = null;

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.classList.remove('team-modal-open');
      if (dialog) dialog.classList.remove('is-hiring');
      if (profilePanel) profilePanel.removeAttribute('hidden');
      modal.querySelectorAll('[data-team-modal-hiring]').forEach(function (panel) {
        panel.setAttribute('hidden', '');
      });
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus({ preventScroll: true });
      }
      lastFocus = null;
    }

    function openProfileModal(payload, trigger) {
      lastFocus = trigger || document.activeElement;
      if (dialog) dialog.classList.remove('is-hiring');
      if (profilePanel) profilePanel.removeAttribute('hidden');
      modal.querySelectorAll('[data-team-modal-hiring]').forEach(function (panel) {
        panel.setAttribute('hidden', '');
      });

      roleEl.textContent = payload.role || '';
      roleEl.hidden = !payload.role;
      nameEl.textContent = payload.name || '';
      bioEl.textContent = payload.bio || '';

      if (payload.photo) {
        img.src = payload.photo;
        img.alt = payload.photoAlt || payload.name || '';
        var posY = typeof payload.photoPositionY === 'number' ? payload.photoPositionY : 30;
        if (posY < 0) posY = 0;
        if (posY > 100) posY = 100;
        img.style.objectPosition = 'center ' + posY + '%';
        if (media) media.style.setProperty('--team-photo-y', posY + '%');
        media.removeAttribute('hidden');
      } else {
        img.removeAttribute('src');
        img.alt = '';
        img.style.objectPosition = '';
        if (media) media.style.removeProperty('--team-photo-y');
        media.setAttribute('hidden', '');
      }

      actionsEl.innerHTML = '';
      if (payload.linkedin) {
        var li = document.createElement('a');
        li.href = payload.linkedin;
        li.target = '_blank';
        li.rel = 'noopener noreferrer';
        li.textContent = payload.linkedinLabel || 'LinkedIn';
        li.className = 'is-primary';
        actionsEl.appendChild(li);
      }
      if (payload.showEmail && payload.email) {
        var mail = document.createElement('a');
        mail.href = 'mailto:' + payload.email;
        mail.textContent = payload.emailLabel || 'Email';
        actionsEl.appendChild(mail);
      }

      modal.removeAttribute('hidden');
      document.body.classList.add('team-modal-open');
      var closeBtn = modal.querySelector('.team-modal__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function openHiringModal(trigger) {
      var panel = modal.querySelector('[data-team-modal-hiring]');
      if (!panel) return;
      lastFocus = trigger || document.activeElement;
      if (dialog) dialog.classList.add('is-hiring');
      if (profilePanel) profilePanel.setAttribute('hidden', '');
      panel.removeAttribute('hidden');
      modal.removeAttribute('hidden');
      document.body.classList.add('team-modal-open');
      requestAnimationFrame(function () {
        var firstField = panel.querySelector('input, textarea, button[type="submit"], a');
        if (firstField) firstField.focus({ preventScroll: true });
        else {
          var closeBtn = modal.querySelector('.team-modal__close');
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        }
      });
    }

    section.addEventListener('click', function (event) {
      var hireBtn = event.target.closest('[data-team-hiring-open]');
      if (hireBtn && section.contains(hireBtn)) {
        event.preventDefault();
        openHiringModal(hireBtn);
        return;
      }

      var memberBtn = event.target.closest('[data-team-open]');
      if (!memberBtn || !section.contains(memberBtn)) return;
      var card = memberBtn.closest('[data-team-member]');
      if (!card) return;
      var payloadNode = card.querySelector('[data-team-payload]');
      if (!payloadNode) return;
      var payload = {};
      try {
        payload = JSON.parse(payloadNode.textContent || '{}');
      } catch (err) {
        return;
      }
      openProfileModal(payload, memberBtn);
    });

    if (modal.querySelector('[data-hiring-force-open]')) {
      openHiringModal(section.querySelector('[data-team-hiring-open]'));
    }

    modal.querySelectorAll('[data-team-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });

    section.querySelectorAll('[data-hiring-cv-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var linkInput = form.querySelector('[data-cv-link]');
        var messageInput = form.querySelector('[data-cv-message]');
        if (!messageInput) return;

        var link = linkInput && linkInput.value ? linkInput.value.trim() : '';
        var message = messageInput.value ? messageInput.value.trim() : '';
        var combined = '';

        if (link) combined += 'CV / portfolio link: ' + link;
        if (message) combined += (combined ? '\n\n' : '') + message;

        messageInput.value = combined || message;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
